import { Box, CircularProgress, Modal } from "@mui/material";
import { useMemo } from "react";
import { RxCross1 } from "react-icons/rx";
import PagePagination from "../../../common/particles.jsx/PagePagination";
import { AiOutlineExport } from "react-icons/ai";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ReportingProductDetailModal = (props) => {
  const {
    open,
    setOpen,
    reportingProduct,
    isReportingProductLoading,
    reqBody,
    setReqBody,
    FETCH_LIMIT,
    handleExport,
    disableExport,
  } = props;

  const handleClose = () => {
    setReqBody((prevValue) => ({ ...prevValue, offset: 1 }));
    setOpen(null);
  };

  const pageCount = useMemo(() => {
    if (reportingProduct && reportingProduct !== undefined) {
      return Math.ceil(reportingProduct.count / FETCH_LIMIT);
    } else {
      return 0;
    }
  }, [reportingProduct]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          width: "80%",
          overflowY: "auto",
          overflowX: "wrap",
          maxHeight: "80vh",
          padding: 0,
        }}
        className="text-left text-[12px]"
      >
        <div className="flex justify-between items-center px-8 py-4">
          <p className="text-bold text-[16px]">Detail {reqBody.product_name}</p>
          <div className="flex gap-2 items-center">
            <button
              type="button"
              className="flex gap-2 items-center bg-green-700 disabled:bg-gray-500 hover:bg-gray-300 rounded-md px-3 py-2 text-white font-bold flex items-center"
              onClick={handleExport}
              disabled={disableExport}
            >
              Export Laporan
              <AiOutlineExport className="text-[16px]" />
            </button>
            <RxCross1
              className="cursor-pointer hover:text-red-500"
              onClick={handleClose}
            />
          </div>
        </div>

        <div className="flex w-full px-8 pb-4">
          <div className="w-full">
            <div className="block overflow-x-auto w-full rounded-md">
              <table className="w-full overflow-x-auto rounded-md border-collapse">
                <thead className="bg-blue-500 text-white">
                  <th className="p-2 text-center">Tanggal Penjualan</th>
                  <th className="p-2 text-center">Outlet</th>
                  <th className="p-2 text-center">Nama Produk</th>
                  <th className="p-2 text-center">Kategori</th>
                  <th className="p-2 text-center">Metode Penjualan</th>
                  <th className="p-2 text-center">Kuantitas</th>
                  <th className="p-2 text-center">Total Penjualan</th>
                </thead>
                <tbody>
                  {reportingProduct &&
                  !isReportingProductLoading &&
                  reportingProduct.data ? (
                    reportingProduct.data.map((item) => (
                      <tr className="border-2">
                        <td className="p-2 text-center">{item.date}</td>
                        <td className="p-2 text-center">{item.outlet}</td>
                        <td className="p-2 text-center">{item.name_product}</td>
                        <td className="p-2 text-center">{item.category}</td>
                        <td className="p-2 text-center">{item.method}</td>
                        <td className="p-2 text-center">{item.quantity}</td>
                        <td className="p-2 text-center">
                          {item.total.toLocaleString("id-ID", {
                            style: "currency",
                            currency: "IDR",
                          })}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="border-2 text-center">
                      <td colSpan={7} className="p-2 text-center">
                        {isReportingProductLoading ? (
                          <CircularProgress size={20} />
                        ) : (
                          "Tidak ada detail produk"
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {reportingProduct && reportingProduct.data !== null ? (
          <div className="px-8 pb-4">
            <PagePagination
              offset={reqBody.offset}
              setOffset={(e) =>
                setReqBody((prevValue) => ({
                  ...prevValue,
                  offset: e,
                }))
              }
              limit={FETCH_LIMIT}
              total={pageCount}
            />
          </div>
        ) : null}
      </Box>
    </Modal>
  );
};
export default ReportingProductDetailModal;
